import config from '../config';
import getJWT from '../jwt';
import request from './';

const HeaderDefault = {
  'Content-Type': 'application/json',
  'Client-ID': config.REACT_APP_HOTEL_SA_CLIENT_ID,
};

const createHotelRequest = method => async (url, params, headers) => {
  const requestHeaders = { ...HeaderDefault, ...headers };
  // start with /details/v2/hotels/ and end with /content
  const hotelContentRegex = new RegExp(
    `^(\/details\/v2\/hotels\/)([^\s]+)(\/content)$`
  );

  if (!hotelContentRegex.test(url)) {
    const routeArray = url.split('/');
    const firstRoute =
      routeArray.length >= 2 && routeArray[1] === 'bff'
        ? routeArray[2]
        : routeArray[1];
    const token = await getJWT(firstRoute);
    requestHeaders.authorization = `Bearer ${token}`;
  }

  return request[method](url, {
    params,
    baseUrl: config.REACT_APP_HOTEL_BASE_URL,
    headers: requestHeaders,
    requireServerTime: true,
  });
};

const get = createHotelRequest('get');
const put = createHotelRequest('put');
const remove = createHotelRequest('remove');
const post = createHotelRequest('post');

export { get, put, remove, post };
